export const Constants = {
  GET_DATA_2: 'Chart.GET_DATA_2',
  SET_DATA_2: 'Chart.SET_DATA_2',
  SET_LOADING_2: 'Chart.SET_LOADING_2',
  GET_DATA_2_API: '/api/v1/report/dashboard_chart_thang_nam'
}
function buidChart2(data) {
  if (!data || data.length == 0) {
    return {
      labels: [],
      datasets: [
        {
          label: 'doanh số',
          data: [0, 0],
        }
      ]
    }
  }
  else {
    let labels = [];
    let datas = [];
    let colors = [];
    for (var i = 0; i < data.length; i++) {
      let item = data[i];
      labels.push(item["NgayBan"]);
      datas.push(item["ThanhTien"]);
    }
    let charts = {
      labels: labels,
      datasets: [
        {
          label: 'doanh số',
          data: datas,
          fill: false,
          lineTension: 0.1,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: 'rgba(75,192,192,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'red',
          pointBackgroundColor: 'red',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'red',
          pointHoverBorderColor: 'red',
          pointHoverBorderWidth: 5,
          pointRadius: 1,
          pointHitRadius: 10,
        }
      ]
    }
    return charts
  }
}

export const getData2 = (formData) => {
  return {
    type: Constants.GET_DATA_2,
    payload: formData
  }
}

export const setData2 = (data2) => {
  return {
    type: Constants.SET_DATA_2,
    payload: data2 ? buidChart2(data2) : buidChart2([])
  }
}

export const setLoading2 = (flag) => {
  return {
    type: Constants.SET_LOADING_2,
    payload: flag
  }
}


// WEBPACK FOOTER //
// ./src/components/Chart2/actions.js